// 图片(正式时需要换成备注的域名)
export const imageUrl = 'https://ossfastmake.mustke.com/'
export const adminUrl = 'https://makeadmin.xshangyun.com/' //正式
// export const adminUrl = 'https://makeadmin.qingsite.cn' //测试

// 测试
export const SOCKET_AI_URL = 'wss://jlsockettest.youzhiapp.com/'  //测试

/** 预上线 正式库 **/
// export const SOCKET_AI_URL = 'wss://jlsockettest-yu.youzhiapp.com/'

/** 正式 **/
// export const SOCKET_AI_URL = 'wss://jlsocket.xshangyun.com/'  //正式